export class FormController {
	static init() {
		document.addEventListener('DOMContentLoaded', () => {
			const autoFocusedElements = document.querySelectorAll('input[data-focus]');
			const element = autoFocusedElements[0] as HTMLElement;
			if (element) {
				element.focus();
			}
		});
	}
}
